import React, { useState } from 'react';
import Image from 'next/image';
import styles from './StatutoryDisclosures.module.scss';
import {
  STATUTORY_DOCUMENTS,
  COMPANY_INFO,
  PAGE_METADATA,
  getFiscalYearsWithCounts,
  getGeneralMeetingsByYear,
} from '@/utils/statutoryDocuments';

const StatutoryDisclosures = () => {
  const [selectedYear, setSelectedYear] = useState('FY 2025-26');
  const fiscalYears = getFiscalYearsWithCounts();
  const meetingsByYear = getGeneralMeetingsByYear();

  const handleDocumentClick = (url) => {
    if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={styles.statutoryDisclosuresSection}>
      <div className={styles.container}>
        <p className={styles.lastUpdated}>LAST UPDATED: {PAGE_METADATA.lastUpdated}</p>
        <h2 className={styles.sectionTitle}>Statutory Disclosures</h2>

        {/* Company Information Section */}
        <div className={styles.companyInfoSection}>
          <h2 className={styles.companyInfoTitle}>Company Information</h2>
          <div className={styles.companyInfoGrid}>
            <div className={styles.infoColumn}>
              <div className={styles.infoItem}>
                <strong>Company Name: </strong>
                <span>{COMPANY_INFO.name}</span>
              </div>
              <div className={styles.infoItem}>
                <strong>CIN: </strong>
                <span>{COMPANY_INFO.cin}</span>
              </div>
              <div className={styles.infoItem}>
                <strong>Registered Office Address: </strong>
                <span>{COMPANY_INFO.registeredOffice.address}</span>
              </div>
            </div>
            <div className={styles.verticalDivider}></div>
            <div className={styles.infoColumn}>
              <div className={styles.infoItem}>
                <strong>Telephone: </strong>
                <span>{COMPANY_INFO.contact.telephone}</span>
              </div>
              <div className={styles.infoItem}>
                <strong>Email: </strong>
                <span>{COMPANY_INFO.contact.email}</span>
              </div>
              <div className={styles.infoItem}>
                <strong>Contact Person for Queries/Grievances: </strong>
                <span>{COMPANY_INFO.contact.contactPerson}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Statutory Documents Section */}
        <div className={styles.documentsSection}>
          <h2 className={styles.documentsTitle}>Statutory Documents</h2>

          {/* Annual Returns */}
          <div className={styles.documentSubsection}>
            <h3 className={styles.subsectionTitle}>Annual Return (Form MGT-7)</h3>
            <div className={styles.documentsGrid}>
              {STATUTORY_DOCUMENTS.annualReturns.map((document) => (
                <button
                  key={document.id}
                  className={styles.documentButton}
                  onClick={() => handleDocumentClick(document.s3Url)}
                  aria-label={`Download ${document.displayName}`}
                >
                  <Image
                    src="/assets/icons/file.svg"
                    alt="PDF"
                    width={18}
                    height={18}
                    className={styles.pdfIcon}
                  />
                  <span>{document.displayName}</span>
                  <Image
                    src="/assets/icons/download.svg"
                    alt="Download"
                    width={16}
                    height={16}
                    className={styles.downloadIcon}
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Notice of General Meetings */}
          <div className={styles.documentSubsection}>
            <h3 className={styles.subsectionTitle}>Notice of General Meeting</h3>
            <div className={styles.meetingsContainer}>
              {/* Year Selector */}
              <div className={styles.yearSelector}>
                {fiscalYears.map((yearData) => (
                  <button
                    key={yearData.year}
                    className={`${styles.yearButton} ${
                      selectedYear === yearData.year ? styles.active : ''
                    }`}
                    onClick={() => setSelectedYear(yearData.year)}
                  >
                    <span>{yearData.year}</span>
                    <span className={styles.yearCount}>{yearData.count}</span>
                  </button>
                ))}
              </div>

              {/* Meeting Documents */}
              <div className={styles.meetingDocuments}>
                <div className={styles.documentsGrid}>
                  {(meetingsByYear[selectedYear] || []).map((document) => (
                    <button
                      key={document.id}
                      className={styles.documentButton}
                      onClick={() => handleDocumentClick(document.s3Url)}
                      aria-label={`Download ${document.displayName}`}
                    >
                      <Image
                        src="/assets/icons/file.svg"
                        alt="PDF"
                        width={18}
                        height={18}
                        className={styles.pdfIcon}
                      />
                      <span>{document.displayName}</span>
                      <Image
                        src="/assets/icons/download.svg"
                        alt="Download"
                        width={16}
                        height={16}
                        className={styles.downloadIcon}
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Compliance Note */}
        <div className={styles.complianceNote}>{PAGE_METADATA.complianceNote}</div>
      </div>
    </div>
  );
};

export default StatutoryDisclosures;
